<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  computed: {
    htmlFontSize() {
      return this.$store.getters['screen/remToPixel'](1)
    },
    bodyFontSize() {
      return this.htmlFontSize * 12 / 32
    }
  },
  watch: {
    htmlFontSize: 'setRootFontSize'
  },
  mounted() {
    this.$store.commit('screen/resizeWindow')
    window.addEventListener('resize', () => {
      this.$store.commit('screen/resizeWindow')
    })

    Vue.config.lang = this.$store.state.language
    this.$nextTick(() => {
      window.document.title = this.$t('header.title')
    })

    this.setRootFontSize()
  },
  methods: {
    setRootFontSize() {
      document.querySelector('html').style = `font-size: ${this.htmlFontSize}px`
      document.body.style = `font-size: ${this.bodyFontSize}px`
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue